import throttle from "lodash/throttle";

class BackToTop {
  constructor() {
    this.backToTop = document.getElementById("back-to-top");
    this.header = document.getElementById("header");
    this.scrollThrottle = throttle(this.addRemoveScrolled, 200).bind(this);
    this.events();
  }

  events() {
    window.addEventListener("scroll", this.scrollThrottle);
  }

  addRemoveScrolled() {
    this.scrolled = window.pageYOffset;
    if (this.scrolled > 100) {
      this.backToTop.classList.add("scrolled");
      this.header.classList.add("scrolled");
    } else {
      this.backToTop.classList.remove("scrolled");
      this.header.classList.remove("scrolled");
    }
  }
}

export default BackToTop;
